/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetInboxResponseCounts,
    GetInboxResponseCountsFromJSON,
    GetInboxResponseCountsFromJSONTyped,
    GetInboxResponseCountsToJSON,
    GetTodoItem,
    GetTodoItemFromJSON,
    GetTodoItemFromJSONTyped,
    GetTodoItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetTodoResponse
 */
export interface GetTodoResponse {
    /**
     * 
     * @type {Array<GetInboxResponseCounts>}
     * @memberof GetTodoResponse
     */
    counts?: Array<GetInboxResponseCounts>;
    /**
     * 
     * @type {Array<GetTodoItem>}
     * @memberof GetTodoResponse
     */
    items?: Array<GetTodoItem>;
}

export function GetTodoResponseFromJSON(json: any): GetTodoResponse {
    return GetTodoResponseFromJSONTyped(json, false);
}

export function GetTodoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTodoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'counts': !exists(json, 'counts') ? undefined : ((json['counts'] as Array<any>).map(GetInboxResponseCountsFromJSON)),
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(GetTodoItemFromJSON)),
    };
}

export function GetTodoResponseToJSON(value?: GetTodoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'counts': value.counts === undefined ? undefined : ((value.counts as Array<any>).map(GetInboxResponseCountsToJSON)),
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(GetTodoItemToJSON)),
    };
}


